export default __webpack_public_path__ + "static/media/logo.71ae3ee7.png";